var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { systemValues } from '../../../../../app.constants';
import { UserService } from '../../../../../services/user.service';
var RelatedInfluencerItemComponent = /** @class */ (function () {
    function RelatedInfluencerItemComponent(_userService) {
        this._userService = _userService;
        this.placeholderAvatar = systemValues.defaultUserAvatarPicture;
        this._readOnlyFixInfluencerlinkParams = { hideBackButton: true };
    }
    RelatedInfluencerItemComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (this.influencer) {
            this.userAvatarPicture = this.influencer.profilePicture;
            this.influencerlink = ["/influencer/" + this.influencer.id + "/overview"];
            this.influencerlinkParams = __assign({}, this._readOnlyFixInfluencerlinkParams, { activeAccount: this._userService.getCompanyId() });
            this._activeAccountSubscription = this._userService.companyId.subscribe({
                next: function (activeAccount) {
                    _this.influencerlinkParams = __assign({}, _this._readOnlyFixInfluencerlinkParams, { activeAccount: activeAccount });
                }
            });
        }
    };
    RelatedInfluencerItemComponent.prototype.ngOnDestroy = function () {
        if (this._activeAccountSubscription) {
            this._activeAccountSubscription.unsubscribe();
        }
    };
    RelatedInfluencerItemComponent.prototype.resolveNoAvatarUrl = function () {
        this.userAvatarPicture = this.placeholderAvatar;
    };
    return RelatedInfluencerItemComponent;
}());
export { RelatedInfluencerItemComponent };



// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-overview/related-influencers/related-influencer-item/related-influencer-item.component.ts.pre-build-optimizer.js